<template>
	<div class="peace-page">
		<NavMenu></NavMenu>
		<div class="scroll-container">
			<div class="scroll-content" :style="scrollStyle">
				<img ref="peaceImage" src="../assets/img/peace.png" class="scroll-image" @load="updateScrollMetrics">
				<span class="scroll-gap" aria-hidden="true"></span>
				<img src="../assets/img/peace.png" class="scroll-image">
				<span class="scroll-gap" aria-hidden="true"></span>
			</div>
		</div>
		<div class="footer">
			<div>Copyright © 2025 Gong Inc.</div> 
			<div>All rights reserved.</div>
		</div>
	</div>
</template>

<script>
	import NavMenu from '../components/nav.vue';
	export default {
		name: 'peace',
		components: {
			NavMenu,
		},
		data() {
			return {
				scrollGap: 10,
				scrollStep: 0,
			}
		},
		computed: {
			scrollStyle() {
				return {
					'--scroll-gap': `${this.scrollGap}px`,
					'--scroll-step': this.scrollStep ? `${this.scrollStep}px` : '100%',
				};
			},
		},
		mounted() {
			window.addEventListener('resize', this.updateScrollMetrics);
			this.$nextTick(this.updateScrollMetrics);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateScrollMetrics);
		},
		methods: {
			updateScrollMetrics() {
				const image = this.$refs.peaceImage;

				if (!image) {
					return;
				}

				const imageWidth = image.getBoundingClientRect().width;

				if (!imageWidth) {
					return;
				}

				const nextGap = imageWidth * 1000 / 2174;
				this.scrollGap = nextGap;
				this.scrollStep = imageWidth + nextGap;
			},
		}
	}
</script>

<style scoped>
	.peace-page {
		background-color: #48A4DC;
		width: 100%;
		height: 100vh;
		position: relative;
	}
	.peace-img {
		width: 100%;
		padding: 0 50px;
	}
	.scroll-container {
		position: absolute;
		overflow: hidden;
		white-space: nowrap;
		width: 85%; /* 或你希望的宽度 */
		margin: 0 auto;
		transform: translate(-50%, -50%);
		top: 50%;
		left: 50%;
	}

	.scroll-content {
		display: inline-flex;
		align-items: center;
		animation: scroll 10s linear infinite; /* 调整时间和速度 */
	}

	.scroll-image {
		width: 100%; /* 或你希望的宽度 */
		flex: 0 0 100%;
		height: auto;
		display: block;
	}

	.scroll-gap {
		flex: 0 0 var(--scroll-gap);
		width: var(--scroll-gap);
	}

	@keyframes scroll {
		from { transform: translateX(0); }
		to { transform: translateX(calc(var(--scroll-step) * -1)); } /* 根据图片数量和容器宽度调整 */
	}
	.footer {
		position: absolute;
		bottom: 26px;
		width: 100%;
		text-align: center;
		color: rgba(0255, 255, 255, .45);
		font-size: 10px;
	}
</style>
